import React from "react";

const IgnitionExploreButton = ({ explore3D, explore3DHandler }) => {
  return (
    <div className="ignition-btn-wrapper">
      {explore3D && <div className="ignition-btn-active"></div>}

      <div className="button center" onClick={explore3DHandler}>
        <div className="button-center center"></div>
        <div className="btn-text">
          <span className="font-bold leading-5">
            Explore<br/>in 3D
          </span>
        </div>
      </div>
    </div>
  );
};

export default IgnitionExploreButton;
